export const INVITEMEMBERS_DIALOG_OPEN = "INVITEMEMBERS_DIALOG_OPEN"
export const INVITEMEMBERS_DIALOG_CLOSE = "INVITEMEMBERS_DIALOG_CLOSE"



// WEBPACK FOOTER //
// ./src/types/actions/invite-members-dialog.js